import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Signed in");
            nav("/", { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-white">
            <div className="hidden lg:flex flex-col justify-between p-12 border-r border-border grid-bg" data-testid="login-hero">
                <div>
                    <img src="/scout-ai-logo.png" alt="Scout AI" className="h-12 w-auto" />
                </div>
                <div className="max-w-md">
                    <p className="font-heading text-3xl font-bold leading-tight">
                        Your AI-powered command center for B2B growth.
                    </p>
                    <p className="text-muted-foreground mt-3">
                        Discover leads, research with AI, manage your pipeline — in one operating system.
                    </p>
                </div>
            </div>

            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-sm space-y-5">
                    <div>
                        <div className="overline text-muted-foreground">Sign in</div>
                        <h1 className="font-heading text-4xl font-black mt-2">Welcome back.</h1>
                    </div>
                    <div className="space-y-3">
                        <div>
                            <label className="overline text-muted-foreground">Email</label>
                            <input
                                data-testid="login-email"
                                type="email" required value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input-os mt-1" placeholder="you@company.com"
                            />
                        </div>
                        <div>
                            <label className="overline text-muted-foreground">Password</label>
                            <input
                                data-testid="login-password"
                                type="password" required value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="input-os mt-1" placeholder="••••••••"
                            />
                            <div className="text-right mt-1">
                                <Link data-testid="goto-forgot" to="/forgot-password" className="text-xs text-brand hover:underline">
                                    Forgot password?
                                </Link>
                            </div>
                        </div>
                    </div>
                    <button
                        data-testid="login-submit"
                        type="submit" disabled={loading}
                        className="btn-primary w-full disabled:opacity-50"
                    >
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                    <div className="text-sm text-muted-foreground text-center">
                        New to Scout AI?{" "}
                        <Link data-testid="goto-signup" to="/signup" className="text-brand font-medium hover:underline">
                            Create an organization
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
